<template>
    <div class="CaseFile">
        <h2>Case File <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /></h2>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Filter by Author:</label>
                    <select v-model="Filters.AuthorID" class="form-control">
                        <option :value="null">ALL</option>
                        <option v-for="author in AvailableAuthors" :value="author.Id">{{author.Name}}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Filter by Key Phrase:</label>
                    <input v-model="Filters.Keywords" type="text" class="form-control" />
                </div>
            </div>
        </div>

        <Vuetable :fields="CaseFileTableOptions.Fields"
                  :data="GroupedDocuments"
                  pagination-path=""
                  :api-mode="false"
                  :detail-row-component="CaseFileChapterSectionsObj"
                  track-by="ChapterName"
                  ref="casefiletable"
                  row-class="row-chapter"
                  @vuetable:cell-clicked="OnCellClicked">


            <template slot="Actions" scope="props">
                <div class="horizontal-icons-padded">
                    <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewGroupedDocument(props.rowData.ChapterName, null)" class="pointer" /></span>
                </div>
            </template>
        </Vuetable>
        <DocumentViewer ref="document-viewer-modal-component" />
        
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSync } from '@fortawesome/free-solid-svg-icons';
    library.add(faSync);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faChevronDown);

    import 'flatpickr/dist/flatpickr.css';
    import DocumentViewer from "./DocumentViewer.vue";
    import CaseFileChapterSections from "./CaseFileChapterSections.vue";
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    

    export default {
        created() {
            EventBus.$on('case-file-updated', chartID => {
                if (chartID == this.ChartRecordId) {
                    this.GetChartRecords();
                }
            });
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == this.ChartRecordId) {
                    this.GetChartRecords();
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('case-file-updated');
            EventBus.$off('profile-update-needed');
        },
        props: [
            "ChartType",
            "ChartRecordId",
            "SubProgramId"
        ],
        data: function () {
            return {
                ChartRecords: [],
                Filters: {
                    AuthorID: null,
                    Keywords: ""
                },
                CaseFileTableOptions: {
                    Fields: [
                        {
                            name: 'ChapterLabel',
                            title: '',
                            titleClass: 'chapter-header',
                        },
                        {
                            name: 'DocCount',
                            title: "",
                            titleClass: 'chapter-header',
                            callback: 'AppendTextToInt| Document| Documents'
                        },
                        {
                            name: '__slot:Actions',
                            title: '',
                            titleClass: 'chapter-header',
                            dataClass: 'right-aligned',
                        }
                    ]
                },
                CaseFileChapterSectionsObj: CaseFileChapterSections
            }
        },
        methods: {
            RefreshDataTable() {
                this.GetChartRecords(true);
            },
            GetChartRecords(loadIndicator) {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetDocumentsForChart", { ChartID: this.ChartRecordId, ChartType: this.ChartType, AuthorID: this.Filters.AuthorID, Keywords: this.Filters.Keywords }, this.GetChartRecordsSuccess, () => { }, loadIndicator);
            },
            GetChartRecordsSuccess(response) {
                this.ChartRecords = response.data.data;
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            OnCellClicked(data, field, event) {   
                let vm = this;
                this.$refs.casefiletable.toggleDetailRow(data.ChapterName);
                this.ChartRecords = this.ChartRecords;
                setTimeout(function () {
                    vm.ChartRecords.forEach(function (item) {
                        if (item.ChapterName != data.ChapterName) {
                            vm.$refs.casefiletable.hideDetailRow(item.ChapterName);
                        }
                    });
                }, 150);
                
            },
            ViewGroupedDocument(chapterName, sectionName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModalWithGroupedDocs(this.ChartRecordId, chapterName, sectionName);
            },
            AppendTextToInt(inputInt, singularString, pluralString) {
                if (inputInt == 1 || inputInt == -1) {
                    return inputInt + singularString;
                } else {
                    return inputInt + pluralString;
                }
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            CaseFileChapterSections,
            DocumentViewer,
            Vuetable
        },
        computed: {
            GroupedDocuments: function () {
                return this.ChartRecords;
            },
            AvailableAuthors: function () {
                let authorIDs = [];
                let authors = [];
                this.ChartRecords.forEach(function (chapter) {

                    chapter.Sections.forEach(function (section) {

                        section.Documents.forEach(function (doc) {

                            if (authorIDs.includes(doc.DocumentAuthorEmployeeID) == false) {
                                authorIDs.push(doc.DocumentAuthorEmployeeID);
                                authors.push({
                                    Name: doc.DocumentAuthorName,
                                    Id: doc.DocumentAuthorEmployeeID
                                });
                            }
                        });
                    });
                });

                return authors;
            }

        },
        mounted: function () {
            this.GetChartRecords(false);
        }
    }
</script>

<style scoped>
    /deep/ .row-chapter {
        border-style: solid;
        background-color: #94a545;
        color: #fff;
        text-transform: uppercase;
        border-color:black;
        cursor: pointer;
        font-size: large;
        font-weight: bold;
    }
    

    .horizontal-icons-padded span {
        padding-right: 20px;
    }

    table {
        table-layout:fixed;
    }

    /deep/ .chapter-header {
        font-size: x-large;
    }

    /deep/ .right-aligned {
        text-align: right;
    }

    .CaseFile {
        background-color: white;
    }
</style>